import { io } from "socket.io-client";
import config from "./api/config";

const { url } = config;
// const socketServerURL = "http://localhost";
// if (ENV_TYPE === 'production') {
//   socketServerURL = 'https://api.pulse-experience.co';
// } else if (ENV_TYPE === 'local') {
//   socketServerURL = 'http://localhost';
// }
const socket = io.connect(url, {
  extraHeaders: {
    "my-custom-header": "abcd",
  },
});
// const socket = { on: () => null, emit: () => null };

export default socket;
